import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../ui/components/ui/dialog";
import Preloader from "../../../ui/components/ui/preloader";

const CreateDialog = () => {
  const messages = [
    "Auftrag wird erstellt",
    "Dateien werden hochgeladen",
    "Dateien werden verarbeitet",
    "Benutzer werden benachrichtigt",
    "Server wird vorbereitet",
    "Daten werden analysiert",
    "Bericht wird generiert",
    "System wird synchronisiert",
    "Ressourcen werden geladen",
    "Aufgabe wird abgeschlossen",
  ];

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    // Interval to rotate messages every 4 seconds
    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 5000);

    return () => clearInterval(messageInterval);
  }, [messages.length]);

  useEffect(() => {
    // Interval to animate the dots every 500ms
    const dotInterval = setInterval(() => {
      setDotCount((prevCount) => (prevCount + 1) % 4); // Rotate from 0 to 3 dots
    }, 500);

    return () => clearInterval(dotInterval);
  }, []);

  return (
    <Dialog open={true}>
      <DialogContent className="sm:max-w-md min-w-[560px] py-4 px-6 gap-5" isClosable={false}>
        <Preloader />
        <DialogHeader className="mb-7">
          <DialogTitle className="flex items-center gap-3 text-center m-auto">
            {messages[currentMessageIndex]}
            {".".repeat(dotCount)}
          </DialogTitle>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default CreateDialog;
